/**
 * <research-filter>: category chips over the research list.
 */

// Dependencies
import { registerComponent } from 'almostnojs';
import { Enhanced } from './enhanced.js';

/**
 * The research list filter.
 */
class ResearchFilter extends Enhanced {

    /**
     * Wire the chips.
     *
     * @returns {void}
     */
    init() {

        // Chips and rows.
        const chips = [...this.querySelectorAll('[data-filter]')];
        const rows = [...this.querySelectorAll('[data-category]')];

        // Pick a category.
        chips.forEach((chip) => this.listen(chip, 'click', () => {
            const category = chip.dataset.filter;
            chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
            rows.forEach((row) => { row.hidden = category !== 'all' && row.dataset.category !== category; });
        }));
    }
}

// Register
registerComponent('research-filter', ResearchFilter);
